export const dashboardRouter = [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/Dashboard.vue')
    }
];
